import React, { memo, useState } from "react";
import { firestore } from "../firebase/config";
import DonorList from "./DonorList";
// import DonorList from './DonorList';
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
} from "firebase/firestore";

export default memo(function SearchDonor() {
  const [pan, setPan] = useState(""); //State to store the pan to be searched
  const [queryResult, setQueryResult] = useState(null); //State to store the search result
  const [isPanEntered, PanEntered] = useState(true);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setQueryResult(null);
    try {
      if (pan !== null && pan !== "") {
        const donorCollection = collection(firestore, "donors");
        const donorQuery = query(
          donorCollection,
          where("pan", ">=", pan),
          orderBy("pan"),
          limit(10)
        );
        getDocs(donorQuery).then((QuerySnapshot) => {
          const donorList = QuerySnapshot.docs.map((donor) => ({
            donorId: donor.id,
            fullName: donor.data().fullName,
            pan: donor.data().pan,
          }));
          setQueryResult(donorList);
          setPan("");
        });
      }
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  return (
    <div style={{ padding: "var(--theme-spacing-xl)", display: "flex", flexDirection: "column", gap: "var(--theme-spacing-xl)" }}>
      <div className="card" style={{ padding: "var(--theme-spacing-lg)" }}>
        <h2 style={{ margin: 0, fontFamily: "var(--theme-font-family-display)", color: "var(--theme-color-primary)", textAlign: "center" }}>
          Search Donor
        </h2>
      </div>

      <div className="card" style={{ padding: "var(--theme-spacing-xl)" }}>
        <form onSubmit={handleFormSubmit} style={{ display: "flex", alignItems: "center", gap: "var(--theme-spacing-md)", flexWrap: "wrap", justifyContent: "center" }}>
          <label style={{ fontWeight: 600, color: "var(--theme-color-ink)", margin: 0 }}>PAN No:</label>
          <input
            type="text"
            className="form-control"
            style={{ maxWidth: "300px" }}
            id="pan"
            placeholder="Enter PAN here"
            name="pan"
            value={pan}
            onChange={(e) => {
              setPan(e.target.value.toUpperCase());
              PanEntered(true);
            }}
          />
          <button type="submit" className="btn btn-primary">
            Search
          </button>
        </form>
      </div>

      {queryResult != null && (
        <div className="card" style={{ padding: "0" }}>
          <div style={{ padding: "var(--theme-spacing-md) var(--theme-spacing-xl)", borderBottom: "1px solid var(--theme-color-canvas-soft)" }}>
            <h4 style={{ margin: 0, color: "var(--theme-color-ink)", fontWeight: 600 }}>Result</h4>
          </div>

          <div style={{ padding: "var(--theme-spacing-xl)" }}>
            <div style={{ color: "var(--theme-color-body)", marginBottom: "var(--theme-spacing-md)" }}>
              Query Results here..
            </div>
            
            {queryResult.length > 0 ? (
              <DonorList queryResult={queryResult} entity="donor" />
            ) : (
              <div style={{ color: "var(--theme-color-ink)", fontWeight: 600, textAlign: "center", padding: "var(--theme-spacing-lg)" }}>
                No donor found
              </div>
            )}

            {!isPanEntered && (
              <div style={{ color: "var(--theme-color-error, #dc3545)", marginTop: "var(--theme-spacing-md)" }}>
                Please enter a search criteria
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
});
